import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const tomoList = ['Fundamentos del Mueble Plegable', 'Mesas y Escritorios Rebatibles', 'Estanterías e Islas Móviles', 'Dormitorios Inteligentes', 'Sillas y Bancos Plegables', 'Taller Plegable'];
const bonusList = ['Calculadora Cero Desperdicio + Cotizador PRO', 'Guía Maestra de Herrajes Plegables', 'Checklist Anti-Errores', 'Kit Publicá & Vendé', 'Plantillas de Precisión', 'Guía de Instalación Segura'];
const flow = ['Planificá', 'Fabricá', 'Cotizá', 'Publicá'];
function Block({
  eyebrow,
  title,
  items,
  image,
  imageAlt
}: {
  eyebrow: string;
  title: string;
  items: string[];
  image: string;
  imageAlt: string;
}) {
  return <div className="overflow-hidden rounded-2xl border border-cream-line bg-white shadow-card" data-id="element-129" data-mp="1itefj2evm37o">
      <img src={image} alt={imageAlt} className="aspect-[16/9] w-full object-cover" loading="lazy" data-id="element-130" data-mp="1wp01f0ptc6vv" />
      <div className="p-6 md:p-7" data-id="element-131" data-mp="2uz3rf450xbtu">
        <p className="font-display text-[10px] font-black uppercase tracking-[0.22em] text-wood-dark" data-id="element-132" data-mp="2uzvlgaiz31i0">
          {eyebrow}
        </p>
        <h3 className="mt-2 font-display text-xl font-black uppercase leading-tight text-ink md:text-2xl" data-id="element-133" data-mp="2zzi10qm9wttz">
          {title}
        </h3>

        <ul className="mt-5 space-y-2.5" data-id="element-134" data-mp="39w4kpc2v5euf">
          {items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-medium leading-snug text-ink/80 md:text-[15px]" data-id="element-135" data-mp="3dxpsij0jj2xr">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-cta" strokeWidth={3.5} data-id="element-136" data-mp="3iug8758fnwin" />
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}
export function WhatYouGet() {
  return <section className="bg-cream-deep py-16 md:py-24" data-id="element-137" data-mp="1hcf91pjspv3">
      <div className="mx-auto max-w-5xl px-5 md:px-8" data-id="element-138" data-mp="5hmnkl0tbsd4">
        <Reveal data-id="element-139" data-mp="5i61lqncdwlv">
          <h2 className="text-center font-display text-2xl font-black uppercase leading-tight text-ink sm:text-3xl md:text-[2.6rem]" data-id="element-140" data-mp="5fjyc37hi39g">
            Todo un sistema
            <span className="block text-wood" data-id="element-141" data-mp="1xk8w4w40ccx3">en un solo lugar</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-142" data-mp="2bbdwy1j43b90">
          <Reveal data-id="element-143" data-mp="26k4996h4ihzr">
            <Block eyebrow="Contenido principal" title="6 Tomos Carpintería Plegable PRO™" items={tomoList} image="https://cdn.magicpatterns.com/patterns/generated-images/46a813cb-72f0-4089-b32d-a7acd3ce0524.jpg" imageAlt="Los seis tomos de Carpintería Plegable PRO alineados sobre un banco de taller" data-id="element-144" data-mp="26jm3nj8kmrf6" />
          </Reveal>

          <Reveal delay={0.06} data-id="element-145" data-mp="2q7lgczmp48n8">
            <Block eyebrow="Incluido sin costo extra" title="+ 6 Bonos" items={bonusList} image="https://cdn.magicpatterns.com/patterns/generated-images/3069d444-2509-4326-a30d-d2cbc065ec5e.jpg" imageAlt="Los seis bonos junto a una calculadora, herrajes, plantillas y un nivel" data-id="element-146" data-mp="2q8mrf43pov4y" />
          </Reveal>
        </div>

        <Reveal delay={0.1} data-id="element-147" data-mp="pqz5oxmzew0t">
          <ol className="mt-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-148" data-mp="ptbi6v9z0e6h">
            {flow.map((step, index) => <React.Fragment key={step} data-id="element-149" data-mp="gydkzbzsif9c" data-mpi={index}>
                {index > 0 && <span className="font-display text-lg font-black text-wood" aria-hidden="true" data-id="element-150" data-mp="2264alnlbvyt">
                    →
                  </span>}
                <li className="font-display text-lg font-black uppercase tracking-tight text-ink md:text-2xl" data-id="element-151" data-mp="3p7dwif8z00yf">
                  {step}
                </li>
              </React.Fragment>)}
          </ol>
        </Reveal>
      </div>
    </section>;
}